module.exports = __webpack_public_path__ + "img/icon_search.a3242a2f.svg";